/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC} from 'react'
import {toAbsoluteUrl} from '../../../../../../../../../_metronic/helpers'
import {Benefit} from '../../core/_models'

type Props = {
  benefit: Benefit
}

const BenefitInfoCell: FC<Props> = ({benefit}) => (
  <div className='d-flex align-items-center'>
    {/* begin:: Avatar */}
    {/* <div className='symbol symbol-circle symbol-50px overflow-hidden me-3'>
      <a href='#'>
        {Benefit.avatar ? (
          <div className='symbol-label'>
            <img src={toAbsoluteUrl(`/media/${Benefit.avatar}`)} alt={Benefit.name} className='w-100' />
          </div>
        ) : (
          <div
            className={clsx(
              'symbol-label fs-3',
              `bg-light-${Benefit.initials?.state}`,
              `text-${Benefit.initials?.state}`
            )}
          >
            {Benefit.initials?.label}
          </div>
        )}
      </a>
    </div> */}
    <div className='d-flex flex-column'>
      <a href='#' className='text-gray-800 text-hover-primary mb-1'>
        {benefit.name}
      </a>
      <span>{benefit.email}</span>
    </div>
  </div>
)

export {BenefitInfoCell}
